<template>
    <PutBackground type="fgr"/>
</template>

<script>
import PutBackground from '@/views/put/Background.vue';

export default {
    components:{
        PutBackground
    },
}
</script>